import React from "react";
import classNames from "classnames";
import styles from "./index.module.scss";

interface MessageAccusedProps {
    className: string;
}

export default function MessageAccused({ className }: MessageAccusedProps) {
    return (
        <div className={className} title="该消息存在违规风险, 等待管理员处理。">
            <div className={classNames(styles.textMsg, styles.accused)}>
                该消息存在违规风险, 等待管理员处理。
            </div>
        </div>
    );
}
